import React from "react";
import StaticArticlePage from "@/components/static/StaticArticlePage";

export default function SafetyChecklistGuide() {
  return <StaticArticlePage pageKey="checklist" />;
}